(function($) {
    $(function() {
        $(document).on('change', '#products_per_page', function() {
          var perPage = $(this).val();
          $(this).parent().find('.limiter-count').html(perPage);
          var perPageData = '{"attributes":{"collection_products_per_page":"'+perPage+'"}}';
          $.ajax({
              url: "/cart/update.js",
              type: "post",
              data: perPageData,
              contentType: "application/json",
              success: function(result) {
                  var queryParams = window.location.search;
                  if (queryParams.indexOf("page=")) {
                    const params = new URLSearchParams(window.location.search);
                    params.delete("page");
                    var newUrl = window.location.origin+window.location.pathname;
                    if (params.size) {
                      newUrl = newUrl+'?'+params;
                    }
                    window.location.href = newUrl;
                  } else {
                    location.reload();
                  }
              }
          });
      });
    });
})(jQuery);
